import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-400 py-8 border-t border-slate-800">
      <div className="container mx-auto px-4 text-center text-sm">
        <p className="mb-2">
          &copy; {new Date().getFullYear()} 維得立/歐得立企業股份有限公司. All Rights Reserved.
        </p>
        <p className="text-slate-500 text-xs">
          專業設計 • 製造廠 • 出租佈展 | 展示櫃 • 展示板 • 標示牌 • 活動展覽牆
        </p>
      </div>
    </footer>
  );
}